import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgHeadset = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 20 20'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <mask
      id='Headset_svg__a'
      width={18}
      height={16}
      x={1}
      y={2}
      maskUnits='userSpaceOnUse'
      style={{
        maskType: 'alpha',
      }}
    >
      <path
        fill={props.color}
        fillRule='evenodd'
        d='M10 2.502a8.335 8.335 0 0 1 8.333 8.334v4.166a2.5 2.5 0 0 1-2.5 2.5H15a2.5 2.5 0 0 1-2.488-2.252l-.012-.248v-2.5a2.5 2.5 0 0 1 2.5-2.5h1.612a6.66 6.66 0 0 0-1.898-3.88 6.667 6.667 0 0 0-11.327 3.88H5a2.5 2.5 0 0 1 2.5 2.5v2.5a2.5 2.5 0 0 1-2.5 2.5h-.834a2.5 2.5 0 0 1-2.5-2.5v-4.167A8.334 8.334 0 0 1 10 2.502m-6.667 12.5a.833.833 0 0 0 .833.833H5a.833.833 0 0 0 .829-.75l.004-.083v-2.5A.833.833 0 0 0 5 11.67H3.333zM15 11.67a.833.833 0 0 0-.834.833v2.5a.833.833 0 0 0 .834.833h.833a.833.833 0 0 0 .833-.833V11.67z'
        clipRule='evenodd'
      />
    </mask>
    <g mask='url(#Headset_svg__a)'>
      <path fill={props.color} d='M0 .001h20v20H0z' />
    </g>
  </svg>
)
const ForwardRef = forwardRef(SvgHeadset)
export default ForwardRef
